export default "__VITE_ASSET__pX9cIMr8__"